
// import createHistory from 'history/createBrowserHistory';
import {createBrowserHistory} from "history";

// const history = createHistory();
const history = createBrowserHistory();

export default history;